/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/MFGTransItemGridEditor.ts" />

namespace TabAurous.Production {

    import fld = JobWorkSettlementDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkSettlementDetailsEditor extends _Ext.MFGTransItemGridEditor<JobWorkSettlementDetailsRow> {



        protected getColumnsKey() { return "Production.JobWorkSettlementDetails"; }
        protected getDialogType() { return JobWorkSettlementDetailsDialog; }
        protected getLocalTextPrefix() { return JobWorkSettlementDetailsRow.localTextPrefix; }
        protected form: JobWorkSettlementDetailsForm;
        public type: string;
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = false;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons(); 
            buttons[0].visible = false;
            var self = this;
            buttons.push({
                title: 'Settle in Amount',
                icon:'fa-money',
                onClick: function () {
                    self.type = "Amount";
                    if (self.view.getItems().length > 0) {
                        q.alert('', 'Cannot add more than one Settlement', true, 2999);
                        return;
                    }

                    buttons[0].onClick();
                }
            },
                {
                    title: 'Settle in Metal',
                    icon: 'fas fa- cubes',
                    onClick: function () {
                        self.type = "Metal";
                        if (self.view.getItems().length > 0) {
                            q.alert('', 'Cannot add more than one Settlement', true, 2999);
                            return;
                        }
                        buttons[0].onClick();
                    }
                }

            )
            return buttons;
        }


    }
}